import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const Loader = ({ styles = {} }) => (
  <Box
    sx={{
      width: '100%',
      height: '88%',
      top: '40px',
      left: '0px',
      opacity: 0.9,
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: '99',
      ...styles,
    }}
  >
    <CircularProgress color="primary" />
  </Box>
);

export default Loader;
